module.exports = __webpack_public_path__ + "static/img/back05.ff9162f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back05.png
// module id = LxYd
// module chunks = 1